"use strict";

import "./Checkbox.css";
import React from "react";
import classnames from "classnames";
import Button from "./../Button";

export default class Checkbox extends React.Component {
	
	constructor(props) {
		super(props);
		this.initState();
	}
	
	initState() {
		this.state = {
			value: this.constructor.getStateByProps(this.props)
		};
	}
	
	static getStateByProps(props) {
		if (props.checked && props.indeterminate)
			return 1;
		else if (props.checked && !props.indeterminate)
			return 2;
		else
			return 0;
	}
	
	clickHandler(evt) {
		evt.stopPropagation();
		
		const newValue = this.state.value > 0 ? 0 : 2;
		
		this.setState({
			value: newValue
		});
		
		this.props.onChange(newValue > 0, newValue == 1);
	}
	
	componentWillReceiveProps(nextProps) {
		if (nextProps.checked == this.props.checked && nextProps.indeterminate == this.props.indeterminate)
			return;
		
		this.setState({
			value: this.constructor.getStateByProps(nextProps)
		});
	}
	
	getIconDescriptor() {
		if (this.props.icon.constructor == String) {
			return this.props.icon;
		}
		else if (this.props.icon.constructor == Object) {
			if ("on" in this.props.icon || "off" in this.props.icon || "indeterminate" in this.props.icon)
				return this.props.icon[this.getValueDescriptor()];
			else if ("type" in this.props.icon && "src" in this.props.icon)
				return this.props.icon;
		}
	}
	
	static getIconType(iconDescriptor) {
		if (iconDescriptor.constructor == String)
			return "icon";
		else if (iconDescriptor.constructor == Object)
			return iconDescriptor.type;
	}
	
	static getIconSource(iconDescriptor) {
		if (iconDescriptor.constructor == String)
			return iconDescriptor;
		else if (iconDescriptor.constructor == Object)
			return iconDescriptor.src;
	}
	
	getButtonIconProps() {
		const iconDescriptor = this.getIconDescriptor();
		let props = {};
		props[this.constructor.getIconType(iconDescriptor)] = this.constructor.getIconSource(iconDescriptor);
		return props;
	}
	
	getValueDescriptor() {
		switch (this.state.value) {
			case 0: return "off";
			case 1: return "indeterminate";
			case 2: return "on";
		}
	}
	
	render() {
		const className = classnames(this.props.className, "Checkbox", {"Checked": this.state.value > 0});
		
		return (
			<div
				className={className}
				onClick={this.clickHandler.bind(this)}
				onDoubleClick={evt => evt.stopPropagation()}
			>
				<div>
					<Button {...this.getButtonIconProps()}/>
					<label>{this.props.children}</label>
				</div>
			</div>
		);
	}
	
}

Checkbox.iconSchema = React.PropTypes.oneOfType([
	React.PropTypes.string,
	React.PropTypes.shape({
		type: React.PropTypes.string,
		src: React.PropTypes.string
	})
]);

Checkbox.propTypes = {
	icon: React.PropTypes.oneOfType([
		Checkbox.iconSchema,
		React.PropTypes.shape({
			on: Checkbox.iconSchema,
			indeterminate: Checkbox.iconSchema,
			off: Checkbox.iconSchema
		})
	]),
	checked: React.PropTypes.bool,
	indeterminate: React.PropTypes.bool,
	onChange: React.PropTypes.func
};

Checkbox.defaultProps = {
	icon: {
		off: "checkbox-blank-outline",
		indeterminate: "checkbox-marked",
		on: "checkbox-marked"
	},
	checked: false,
	indeterminate: false,
	onChange: value => {}
};


// WEBPACK FOOTER //
// ./~/vwa/components/Checkbox/Checkbox.jsx